import { useGo } from "@refinedev/core";
import { useParams } from "react-router-dom";

type ProjectRouteParams = {
  id: string;
  storyboardId?: string;
  instanceId?: string;
};
interface ProjectNavigateParams {
  projectId: string;
  storyboardId?: string;
  instanceId?: string;
  subRoute?: string;
}

export const useProjectNavigate = () => {
  const go = useGo();
  const params = useParams<ProjectRouteParams>();

  const getProjectRoute = ({
    projectId,
    storyboardId,
    instanceId,
    subRoute,
  }: ProjectNavigateParams) => {
    if (!projectId) {
      throw new Error("projectId is required for project navigation");
    }

    // Build the route based on available parameters
    let route = `/media/projects/${projectId}`;

    if (storyboardId) {
      route += `/${storyboardId}`;
    }

    if (instanceId) {
      route += `/${instanceId}`;
    }

    if (subRoute) {
      route += `/${subRoute}`;
    }

    return route;
  };
  const navigateToProject = ({
    projectId,
    storyboardId,
    instanceId,
    subRoute,
  }: ProjectNavigateParams) => {
    const route = getProjectRoute({
      projectId,
      storyboardId,
      instanceId,
      subRoute,
    });
    go({
      to: route,
    });
  };

  const navigateToStoryboard = ({
    projectId,
    storyboardId,
    instanceId,
    subRoute = "",
  }: ProjectNavigateParams) => {
    navigateToProject({
      projectId,
      storyboardId,
      instanceId,
      subRoute: "script" + (subRoute ? `/${subRoute}` : ""),
    });
  };

  const navigateToTemplates = ({
    projectId,
    storyboardId,
    instanceId,
  }: ProjectNavigateParams) => {
    navigateToProject({
      projectId,
      storyboardId,
      instanceId,
      subRoute: "storyboard/templates",
    });
  };

  return {
    navigateToProject,
    navigateToStoryboard,
    navigateToTemplates,
    getProjectRoute,
    params: { ...params, projectId: params?.id },
  };
};
